export default __webpack_public_path__ + "static/media/Bottom_profile_selected.66791bb2.svg";